module.exports = __webpack_public_path__ + "img/Perks-20.eccc353d.png";